import { Guid } from '@web/utils';
import { BoxQuestionnaireStatus } from '../../shared/enums';

export class PublicBoxRecommendedQuestionnaire {
  public constructor(
    private readonly data: {
      id: Guid;
      name: string;
      status: BoxQuestionnaireStatus;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get name(): string {
    return this.data.name;
  }

  public get status(): BoxQuestionnaireStatus {
    return this.data.status;
  }
}
